// extracted by mini-css-extract-plugin
export var productImage = "_lm-1";
export var viewLink = "_lm-2";
export var wishlistItem = "_lm-0";